import { render, staticRenderFns } from "./BitsInvoiceWelcome.vue?vue&type=template&id=50444684&scoped=true"
import script from "./BitsInvoiceWelcome.vue?vue&type=script&lang=js"
export * from "./BitsInvoiceWelcome.vue?vue&type=script&lang=js"
import style0 from "./BitsInvoiceWelcome.vue?vue&type=style&index=0&id=50444684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50444684",
  null
  
)

export default component.exports